import React from 'react'
import NotFoundErrorContainer from 'src/containers/Error/404'

const NotFoundErrorPage: React.FC = () => {
  return <NotFoundErrorContainer />
}

export const PATH = '/404' as const
export default NotFoundErrorPage
